// extracted by mini-css-extract-plugin
export const menu = "wp-menu-module--menu--1GtJU";
export const header = "wp-menu-module--header--15iFI";
export const mobilebutton = "wp-menu-module--mobilebutton--ijxRG";
export const submenu = "wp-menu-module--submenu--3BSDc";
export const active = "wp-menu-module--active--6Exea";
export const svgwrapper = "wp-menu-module--svgwrapper--3_UWS";
export const mobile = "wp-menu-module--mobile--1h2nT";
export const blocker = "wp-menu-module--blocker--1fw2H";
export const blockerInner = "wp-menu-module--blockerInner--20ScI";